export const aboutHeroSubtitle = 'About SALTED';
export const aboutHeroTitle = 'Understanding Human Movement.\nExpanding Life.';
export const aboutHeroDescription = '인류의 움직임을 디지털로 번역하고,\n삶의 가능성을 확장합니다';

// Tab Navigation
export const tabStory = '기업소개';
export const tabCompetency = '핵심 역량';
export const tabHistory = '회사 연혁';
export const tabPeople = '피플';
export const tabPartner = '파트너';
export const tabCI = 'CI';

// Origin Story Section
export const originSectionTitle = '시작은 아주 단순한 질문이었습니다';
export const originText1 = '솔티드는 삼성전자 사내벤처 시절,\n아주 작은 생각에서 출발했습니다.';
export const originText2 = '인류에게 가장 보편적이면서도\n가장 중요한 행동은 무엇일까.';
export const originText3 = '그 질문의 답은 \'걷기\'였습니다.';
export const originText4 = '걷는다는 것은 사람이 매일 반복하는\n가장 일상적인 행동이자,\n건강과 균형, 신체 상태를 가장 자연스럽게\n나타내는 움직임입니다.';
export const originText5 = '사람은 매일 걷습니다.\n의료 기술은 빠르게 발전해 왔지만,\n\'얼마나 잘 걷고 있는지\'를 객관적으로\n설명해 주는 방법은 여전히 충분하지 않았습니다.';

// Ground Truth Section
export const groundTruthTitle = '답은 늘 발 아래에 있었습니다';
export const groundTruthText1 = '우리는 수많은 보행 데이터를 분석하며 인간 움직임의 가장 중요한 정보는 발과 지면이 만나는 지점에 있다는 것을 발견했습니다.';
export const groundTruthText2 = '족저압, 지면 반발력, 압력 중심의 이동은 사람의 몸 상태와 균형, 기능 변화를 가장 솔직하게 드러내는 신호입니다.';
export const groundTruthText3 = '솔티드는 이 신호를 제대로 이해하기 위해 센서를 설계하고, 데이터를 쌓고, 분석 모델을 수없이 반복하며 고도화해 왔습니다.';
export const groundTruthText4 = '그 과정에서 스마트 인솔 기술이 탄생했고, 인간의 움직임을 해석하는 플랫폼 \'뉴로게이트\'가 만들어졌습니다.';
export const groundTruthText5 = '이것이 솔티드가 인간 움직임을 이해하고 해석하기 시작한 방식입니다.';

// Technology Section
export const technologyTitle = '우리는 측정만 하는 회사가 아닙니다';
export const technologyText1 = '솔티드는 보행과 균형, 자세에서 발생하는 사람의 물리적 신호를 수집합니다.';
export const technologyText2 = '우리는 수집에 멈추지 않습니다.';
export const technologyText3 = '스포츠 산업에서는 사용자의 퍼포먼스 향상을 목표로 골프, 러닝, 트레이닝 시장에 도전하며 움직임 데이터를 훈련과 성과 개선에 활용해 왔습니다.';
export const technologyText4 = '의료 산업에서는 특정 질병과 연관된 움직임을 평가할 수 있도록 보행과 균형, 자세를 기반으로 한 신체기능평가 솔루션을 구축했습니다.';
export const technologyText5 = '이를 통해 의료진이 환자의 상태를 보다 객관적으로 이해하고, 진단과 치료에 활용할 수 있는 기준을 만들어 왔습니다.';

// Vision Section
export const visionTitle = '우리의 비전';
export const visionText1 = '솔티드의 비전은 인류의 움직임을 디지털로 번역하고, 삶의 가능성을 확장하는 것입니다.';
export const visionText2 = '움직임은 생존과 건강, 그리고 자유의 문제입니다.';
export const visionText3 = '우리는 보행과 균형을 디지털 언어로 풀어냄으로써, 더 많은 사람들이 더 오래, 더 안전하게, 자신의 삶을 스스로 걸어갈 수 있도록 돕고자 합니다.';

// Mission Section
export const missionTitle = '우리의 미션';
export const missionText1 = '우리는 2030년까지\n인간의 움직임을 이해하는\nPhysical OS를\n완성하고자 합니다.';
export const missionText2 = '이 Physical OS는 AI가 인간의 몸을 이해할 수 있도록 돕는 공통 기반이 될 것입니다.';
export const missionText3 = '의료 진단, 로봇 제어, 맞춤형 보험, 스포츠 산업 등—\n서로 다른 산업이 같은 기준 위에서 작동할 수 있도록 하는 인프라입니다.';
export const missionText4 = '우리는 제품을 만드는 것이 아니라,\nAI 시대에 인간의 몸을 이해하는 기준을 만들고 있습니다.';

// CEO Message Section
export const ceoMessageTitle = 'CEO Message';
export const ceoText1 = '솔티드는 인류의 가장 근본적인 움직임인 \'걷는 힘\'에서 시작했습니다.';
export const ceoText2 = '우리는 걷는다는 가장 일상적인 행동 속에, 인간의 건강과 균형, 그리고 삶의 지속 가능성을 가늠할 수 있는 가장 본질적인 정보가 담겨 있다고 믿어왔습니다.';
export const ceoText3 = '기술은 빠르게 발전해 왔지만, 인간의 몸을 제대로 이해하는 기준은 아직 충분히 정립되지 않았습니다.';
export const ceoText4 = '솔티드는 이 공백을 해결하는 것이 AI 시대에 반드시 필요한 다음 단계라고 생각합니다.';
export const ceoText5 = '우리는 2030년까지 인간 움직임을 이해하는 Physical OS를 완성하고자 합니다.';
export const ceoText6 = '이는 단일 제품이나 기술을 넘어, 사람과 기술이 만나는 방식을 바꾸는 출발점이 될 것이라 믿습니다.';
export const ceoText7 = '솔티드의 목표는 모든 사람이 더 오래, 더 안전하게, 자기 삶을 스스로 걸어갈 수 있는 세상을 만드는 것입니다.';
export const ceoText8 = '인간의 움직임을 이해하는 기준을 세우는 일은 곧 삶의 가능성을 넓히는 일이라 믿기에, 우리는 이 길을 멈추지 않고 계속 도전할 것입니다.';
export const ceoName = '조형진';
export const ceoTitle = '대표이사, 솔티드 주식회사';

// CTA Section
export const ctaTitle = '솔티드와 함께 시작하세요';
export const ctaDescription = '혁신적인 솔루션으로 여러분의 비즈니스를 다음 단계로 이끌어드립니다';
export const ctaButton = '문의하기';

export default {
  aboutHeroSubtitle,
  aboutHeroTitle,
  aboutHeroDescription,
  tabStory,
  tabCompetency,
  tabHistory,
  tabPeople,
  tabPartner,
  tabCI,
  originSectionTitle,
  originText1,
  originText2,
  originText3,
  originText4,
  originText5,
  groundTruthTitle,
  groundTruthText1,
  groundTruthText2,
  groundTruthText3,
  groundTruthText4,
  groundTruthText5,
  technologyTitle,
  technologyText1,
  technologyText2,
  technologyText3,
  technologyText4,
  technologyText5,
  visionTitle,
  visionText1,
  visionText2,
  visionText3,
  missionTitle,
  missionText1,
  missionText2,
  missionText3,
  missionText4,
  ceoMessageTitle,
  ceoText1,
  ceoText2,
  ceoText3,
  ceoText4,
  ceoText5,
  ceoText6,
  ceoText7,
  ceoText8,
  ceoName,
  ceoTitle,
  ctaTitle,
  ctaDescription,
  ctaButton
};